<template>
  <div class="twitter-navigation">
    <div class="twitter-navigation__wrapper">
      <!-- Minus Icon -->
      <div
        class="twitter-navigation__zoom-icon twitter-navigation__zoom-icon--left"
        @click="zoomOut"
      >
        <svg
          width="8"
          height="4"
          viewBox="0 0 8 4"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.00426 0.826704V3.22727H0.370739V0.826704H7.00426Z"
            fill="black"
          />
        </svg>
      </div>

      <div
        class="twitter-navigation__line-wrapper"
        ref="line"
        @mousedown="onStart"
        @touchstart="onStart"
      >
        <div class="twitter-navigation__line">
          <div
            class="twitter-navigation__fill"
            :style="{
              flexGrow: zoom
            }"
          ></div>
          <div
            class="twitter-navigation__circle"
            :class="{ 'twitter-navigation__circle--focus': focus }"
            :style="{
              left: `${zoom * 100}%`
            }"
          >
            <div
              class="twitter-navigation__inner-circle"
              :class="{ 'twitter-navigation__inner-circle--focus': focus }"
            ></div>
          </div>
        </div>
      </div>

      <!-- Plus Icon -->
      <div
        class="twitter-navigation__zoom-icon twitter-navigation__zoom-icon--right"
        @click="zoomIn"
      >
        <svg
          width="11"
          height="11"
          viewBox="0 0 11 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.52557 10.2116V0.154829H7.06818V10.2116H4.52557ZM0.768466 6.45455V3.91193H10.8253V6.45455H0.768466Z"
            fill="black"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    zoom: {
      type: Number,
      default: 0
    }
  },

  data: () => ({
    focus: false
  }),

  mounted() {
    window.addEventListener('mouseup', this.onStop, { passive: false })
    window.addEventListener('mousemove', this.onDrag, { passive: false })
    window.addEventListener('touchmove', this.onDrag, { passive: false })
    window.addEventListener('touchend', this.onStop, { passive: false })
  },

  destroyed() {
    window.removeEventListener('mouseup', this.onStop)
    window.removeEventListener('mousemove', this.onDrag)
    window.removeEventListener('touchmove', this.onDrag)
    window.removeEventListener('touchend', this.onStop)
  },

  methods: {
    onDrag(e) {
      if (this.focus) {
        const position = e.touches ? e.touches[0].clientX : e.clientX
        const line = this.$refs.line

        if (line) {
          const { left, width } = line.getBoundingClientRect()
          this.$emit(
            'change',
            Math.min(1, Math.max(0, position - left) / width)
          )
        }
        if (e.preventDefault) {
          e.preventDefault()
        }
      }
    },

    zoomIn() {
      this.$emit('change', Math.min(1, this.zoom + 0.1))
    },

    zoomOut() {
      this.$emit('change', Math.max(0, this.zoom - 0.1))
    },

    onStop() {
      this.focus = false
    },

    onStart(e) {
      this.focus = true
      this.onDrag(e)
    }
  }
}
</script>

<style lang="scss" scoped>
.twitter-navigation {
  display: flex;
  width: 42%;
  align-items: center;
  justify-content: center;
  height: 50px;
  &__wrapper {
    display: flex;
    align-items: center;
    max-width: 400px;
    width: 100%;
  }
  &__zoom-icon {
    cursor: pointer;
    width: 18.75px;
    fill: rgb(101, 119, 134);
    flex-shrink: 0;
    &--left {
      margin-right: 10px;
    }
    &--right {
      margin-left: 10px;
    }
  }
  &__line-wrapper {
    width: 100%;
    height: 20px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    border-radius: 5px;
    cursor: pointer;
  }
  &__line {
    background: #232220;
    height: 1px;
    width: 100%;
    border-radius: 5px;
    display: flex;
    position: relative;
    align-items: center;
  }
  &__fill {
    background: #232220;
    align-self: stretch;
    flex-basis: auto;
    flex-direction: column;
    flex-shrink: 0;
  }
  &__circle {
    width: 30px;
    height: 30px;
    margin-left: -15px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    transition-duration: 0.2s;
    transition-property: background-color, box-shadow;
    background-color: transparent;
  }
  &__inner-circle {
    width: 21px;
    height: 21px;
    border-radius: 50%;
    background-color: #232220;
    transform: scale(1);
    transition-duration: 0.1s;
    transition-property: transform;

    &--focus {
      transform: scale(1.2);
    }
  }
}
</style>
